import { useCreateSubscriptionMutation, useMyBoxSettingsQuery } from 'lib/home/generated/queries';
import { useEffect } from 'react';
import { useRegistrationStore } from '../../store';

export const useEnsureSubscriptionStarted = () => {
  const { data: myBoxSettings, refetch: refetchMyBoxSettings } = useMyBoxSettingsQuery();
  const { promoCode, selectedPlan, referralCode } = useRegistrationStore();
  const { mutate } = useCreateSubscriptionMutation({ onSuccess: () => refetchMyBoxSettings() });

  useEffect(() => {
    if (!myBoxSettings?.me) return;
    if (!myBoxSettings.me.subscription) {
      mutate({
        createUserSubscriptionInput: {
          product_variant_id: selectedPlan,
          promo_code: promoCode,
          referral_code: referralCode
        }
      });
    }
  }, [myBoxSettings]);

  return myBoxSettings;
};
